import { cartDomain } from '@stores/cart/domain';

import { ApiError } from '@api/client/errors';

import { SnackBar } from '@utils/snackbar';

export const errorNotificationFx = cartDomain.createEffect<ApiError, void, void>().use((error) => {
    SnackBar.handleApiError(error);
});
